import ttest from 'ttest'
import stratifyVar from '../refs/stratifyVar';
import categoryTracks from '../refs/categoryTracks';
import categoryTracksPCC from '../refs/categoryTracksPCC';
import trackDetail from '../refs/trackDetails';
import trackDetailPCC from '../refs/trackDetailsPCC';

export default function generateBoxplot({
  divId,
  track,
  trackData,
  dataKeys,
  stratify,
  stratifyBy,
  useZScore,
  cohortSelected,
  combinedCohort,
  studySelected,
  stratifyByPrimary
}) {    
  console.log('testboxploly')  
  console.log('boxplotly js cohortSelected', cohortSelected)  
  console.log('boxplotly js dataKeys', dataKeys)
  console.log('boxplotly js combinedCohort', combinedCohort)

  const categoryByStudyDict = {'PTRC': categoryTracks, 'PCC': categoryTracksPCC}
  const categoryByStudy = categoryByStudyDict[studySelected]

  const trackDetailDict = {'PTRC': trackDetail, 'PCC': trackDetailPCC}
  const trackDetails = trackDetailDict[studySelected]
  console.log('boxplotly js categoryByStudy', categoryByStudy)
  var stratifyByPrimary_ = stratifyByPrimary
  // make sure default will be response/tissue_level at least
  if (checkInput(stratifyByPrimary)) {
    stratifyByPrimary_ = stratifyVar[studySelected]['VarName']
    console.log('boxplotly js stratifyByPrimary', stratifyByPrimary)
  }

  console.log('boxplotly js stratifyByPrimary_', stratifyByPrimary_)

  var sort_by = [stratifyByPrimary_, stratifyBy]

  const Plotly = window.Plotly
  const suffixes = {
    'CNV': 'log2 ratio',
    'RNA': 'log TPM',
    'Proteo': 'log2 intensity',
    'CellType': 'Portion',
    'Kinase': 'z-score', 
    'TranscriptionFactor': 'z-score', 
    'ubiq': 'z-score', 
    'glyco': 'z-score', 
    'phospho': 'z-score',
    'Mutation': '0: Wildtype, 1: Mutation'
  }
  const dataType = track.split(' ')[1]  
  console.log('boxplotlyjs datatype', dataType, suffixes[dataType])

  if (!trackData) { return }
    // if (cohortSelected.length > 0) {

  var numCohortAvailable = 0
  var idInCohort_;
  let singleCohortToShow = combinedCohort || studySelected === "PCC"
  // var groupA_;
  // var groupB_;
  // var groupA_Samples;
  // var groupB_Samples;
  var groups_dataSample_array = {}
  // if (singleCohortToShow) {
  //   Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails]) => {
  //     group_ = trackData[cat]
  //     if (!group_)  { return }
  //     group_Samples = Object.keys(group_.data)
  //     groups_dataSample_array[catName] = group_Samples
  //     if (group_Samples.length > 0) {
  //       numCohortAvailable = 1
  //     }
  //   })
  // } else {
  //   cohortSelected.forEach(cohort => {
  //     idInCohort_ = Object.keys(trackData.cohort.data).filter(id => trackData.cohort.data[id] === cohort)
  //     Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails]) => {
  //       group_ = trackData[cat]
  //       if (!group_)  { return }
  //       group_Samples = Object.keys(group_.data).filter(s => idInCohort_.includes(s))
  //       // groupA_Samples = Object.keys(groupA_.data).

  //       groups_dataSample_array[catName] = group_Samples
        
  //     })
  //     if (group_Samples.length > 0) {
  //         numCohortAvailable = 1
  //     }
  //   })
  // }

      // if (singleCohortToShow){
      //   // show both discovery and validation cohort in one boxplot
      //   // idInCohort_ = Object.keys(trackData.cohort.data).filter(id => trackData.cohort.data[id] === cohort)
      //     groupA_ = trackData[dataKeys[0]]
      //     groupB_ = trackData[dataKeys[1]]

      //     console.log('test datakey', dataKeys)
      //     // console.log(dataKeys[0])
      //     if (!groupA_ || !groupB_) { return }

      //     groupA_Samples = Object.keys(groupA_.data)
      //     groupB_Samples = Object.keys(groupB_.data)
      //     if (groupA_Samples.length > 0 || groupB_Samples.length > 0) {
      //       numCohortAvailable += 1
      //     }
      // } else {
      //   cohortSelected.forEach(cohort => {
      //     idInCohort_ = Object.keys(trackData.cohort.data).filter(id => trackData.cohort.data[id] === cohort)
      //     groupA_ = trackData[dataKeys[0]]
      //     groupB_ = trackData[dataKeys[1]]
      //     console.log('test datakey', dataKeys)
      //     console.log(dataKeys[0])
      //     if (!groupA_ || !groupB_) { return }

      //     groupA_Samples = Object.keys(groupA_.data).filter(s => idInCohort_.includes(s))
      //     groupB_Samples = Object.keys(groupB_.data).filter(s => idInCohort_.includes(s))
      //     if (groupA_Samples.length > 0 || groupB_Samples.length > 0) {
      //       numCohortAvailable += 1
      //     }
      //   })
      // }
      console.log('boxplotly js numCohortAvailable', dataKeys[0], numCohortAvailable)
      

      console.log('boxplotly js cohortSelected.length', cohortSelected.length)
      var data = []
      

      var xaxis_title = 'Cohort'
      if (stratify) {
        xaxis_title = `${stratifyBy}<br>(Cohort)`
        if (singleCohortToShow) {
          xaxis_title = stratifyBy
        }
      } else if (singleCohortToShow) {
        // xaxis_title = stratifyVar[studySelected]['VarNameShow']
        xaxis_title = stratifyByPrimary_
      }

      let layout = {
        yaxis: {
          title: useZScore ? 'z-score' : suffixes[dataType],
          zeroline: false,
          hoverformat: '.2f'
        },
        xaxis: {
          type: 'category',
          showgrid: true,
          title: xaxis_title,
          // automargin: true,
          
          zeroline: false,
        },
        // shared_xaxes: true,
        mirror: false,
        automargin: true,
        boxmode: 'group',
      };
       
      let xaxis_label_array = []
      let annotations = []

      if (numCohortAvailable === 2) {
        // layout.xaxis.categoryarray = ['']
      }

      let colors = ['#005AB5', '#DC3220', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51']
      // plot

      // var plotted = new Set()
      var x_axis_tick = 0
      var x_axis_ticks_array = []
      var x_axis_tickslabel_array = []
      let offset_const = 'combined'
      let offsetgroups = Array(10).fill(offset_const)

      // if (!combinedCohort) {
      //   offsetgroups = [`${dataKeys[0]}`, `${dataKeys[1]}`]
      // }
      var cat_color_array = []
      var plotted = 0
      cohortSelected.forEach(cohort => {
        console.log('boxplotly js cohort', cohort)
        console.log('boxplotly js trackData', trackData)
        var idInCohort = Object.keys(trackData.cohort.data).filter(id => trackData.cohort.data[id] === cohort)
        
        console.log('boxplotly js idInCohort', cohort, idInCohort.length)
        if (idInCohort.length === 0) { return }
        
        
        
        
        console.log('boxplotly', trackData)
        let cohortMarker = 'triangle-up'
        if (cohort == 'validation') {
          cohortMarker = 'circle'
        }


        idInCohort_ = Object.keys(trackData.cohort.data).filter(id => trackData.cohort.data[id] === cohort)
        var groups_dataSample_array = {}
        var group_data_array = {}
        Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails]) => {
          if (checkInput(catDetails.label)) { return }
          // dataKeys.forEach(dataKey => {
          var dataKey = `${track} (${catDetails.label})`
            console.log('boxplotly js dataKey', dataKey)
        // Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails]) => {
          var group_ = trackData[dataKey]
          var group_Samples = Object.keys(group_.data)
          if (!group_)  { return }
          group_data_array[dataKey] = group_
          if (!combinedCohort) {
            group_Samples = Object.keys(group_.data).filter(s => idInCohort_.includes(s))
          }
          group_Samples.sort()
          groups_dataSample_array[dataKey] = group_Samples
          
        })
        // let groupA = trackData[dataKeys[0]]
        // let groupB = trackData[dataKeys[1]]
        // console.log('test datakey', dataKeys)
        // console.log(dataKeys[0])
        // if (!groupA || !groupB) { return }

        // var groupASamples, groupBSamples;
        // if (combinedCohort) {
        //   groupASamples = Object.keys(groupA.data)
        //   groupBSamples = Object.keys(groupB.data)

        // } else {
        //   groupASamples = Object.keys(groupA.data).filter(s => idInCohort.includes(s))
        //   groupBSamples = Object.keys(groupB.data).filter(s => idInCohort.includes(s))
        // }
        // groupASamples.sort()
        // groupBSamples.sort()

        // console.log('boxplotly js groupA', groupA)
        var cohortOpacity = 0.97
        
        if (stratify) {

          const categories = trackData[stratifyBy].clinicalData.trackDetails.map(el => el.label)

          categories.forEach(category => {

            // if (singleCohortToShow) {
            //   if (plotted.has(category)) {
            //     return;
            //   } else {
            //     plotted.add(category)
            //   }
            // }
            console.log('boxplotly js category', category)
            // let groupAStratifyLabels = groupASamples.map(s => trackData[stratifyBy].data[s])
            // let groupBStratifyLabels = groupBSamples.map(s => trackData[stratifyBy].data[s])
            var group_cat_data_arrays_ptest = [] 
            var cat_cohort_label = `${category}<br>(${cohort})`
            if (singleCohortToShow) {
              cat_cohort_label = `${category}`
            }
            Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails2]) => {
              if (checkInput(catDetails2.label)) { return }
              var dataKey2 = `${track} (${catDetails2.label})`
              let groupACat = groups_dataSample_array[dataKey2].filter(s => trackData[stratifyBy].data[s] === category)
              // let groupBCat = groupBSamples.filter(s => trackData[stratifyBy].data[s] === category)
              // console.log('boxplotly js groupACat',groupACat.map(s => groupA.data[s]))

              // var cat_cohort_class_label = `${category}<br>${cohort}<br>${dataKeys[0]}`,
              let color_ = catDetails2.color
              
              let trace1 = {
                y: groupACat.map(s => trackData[dataKey2].data[s]),
                // name: `${groupA.label}`,
                // name: `${cohort}`,
                // name: `${category}`,
                // name: `${category}<br>${cohort}<br>${dataKeys[0]}`,
                
                marker: {
                  color: darkenHex(color_),
                  symbol: cohortMarker
                },
                type: 'box',
                boxpoints: 'all',
                jitter: 0.4,
                pointpos: 0,
                showlegend: false,
                opacity: cohortOpacity,
                // offsetgroup: `${category}<br>${cohort}<br>${dataKeys[0]}`,
                // offsetgroup: `${category}<br>${cohort}`,
                offsetgroup: catDetails2.label
                // offsetgroup: offsetgroups[0]
              }
              
              let pValue;
              if (numCohortAvailable === 2) {
                layout.xaxis.categoryarray = cohortSelected
              }

              // x_axis_ticks_array
              trace1.x = new Array(groupACat.length).fill(cat_cohort_label);

              var new_data = [trace1]
              data.push(...new_data)
              plotted += 1
              // trace2.x = new Array(groupBCat.length).fill(cat_cohort_label);
              
              // trace1.x = [new Array(groupACat.length).fill(cohort),
              //             new Array(groupACat.length).fill(category),
              //             ];
              // // trace2.x = new Array(groupBCat.length).fill(cat_cohort_label);
              // trace2.x = [new Array(groupBCat.length).fill(cohort),
              //             new Array(groupBCat.length).fill(category),
              //             ];
              xaxis_label_array.push(cat_cohort_label)
              
              // console.log('boxplotlyjs groupAStratifyLabels', groupAStratifyLabels)
            // trace1.x = groupAStratifyLabels
            // trace2.x = groupBStratifyLabels
            
            
            // layout.xaxis.categoryarray = categories


            // categories.forEach(category => {
              let groupACategorySamples = groups_dataSample_array[dataKey2].filter(s => trackData[stratifyBy].data[s] === category)
              // let groupBCategorySamples = groupBSamples.filter(s => trackData[stratifyBy].data[s] === category)

              let groupACategoryValues = groupACategorySamples.map(s => group_data_array[dataKey2].data[s]).filter(el => el)
              // let groupBCategoryValues = groupBCategorySamples.map(s => groupB.data[s]).filter(el => el)
              group_cat_data_arrays_ptest.push(groupACategoryValues)
            })
            var pValue = 'NaN'
            if (group_cat_data_arrays_ptest.length === 2) {
              pValue = ttest(group_cat_data_arrays_ptest[0], 
                group_cat_data_arrays_ptest[1]).pValue().toExponential(2).toString()
            } else {
              pValue = 'NaN'
            
            }
            // pValue = ttest(groupACategoryValues, groupBCategoryValues).pValue().toExponential(2).toString()

            // if (pValue.includes('e')) {
            //   const pValArr = pValue.split('e')
            //   const val = pValArr[0].slice(0,4)
            //   const exp = pValArr[1]
            //   pValue = `${val}e${exp}`
            // }
            if (!isNaN(pValue)){
              annotations.push({
                x: cat_cohort_label,
                y: 1.1,
                xref: 'x',
                yref: 'paper',
                text: pValue.includes('NaN') ? '' : `pValue:<br>${pValue}`,
                showarrow: false,
              })
            }

          })
        } else {
          // console.log('boxplotly js groupASamples',groupASamples.map(s => groupA.data[s]))
          var xaxis_label_A = `${cohort}`
          // var xaxis_label_B = `${cohort}`
          var pVal_loc = cohort
          if (!singleCohortToShow) {
              offsetgroups = [...dataKeys, null]
          } else {
            console.log('boxplotly js singleCohortToShow', singleCohortToShow)
            pVal_loc = 0.5
          }
          var group_cat_data_arrays_ptest = []
          var offset_idx = 0
          Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails3]) => {
            if (checkInput(catDetails3.label)) { return }
              // dataKeys.forEach(dataKey => {
            var dataKey3 = `${track} (${catDetails3.label})`
            
            if (singleCohortToShow) {
              xaxis_label_A = catDetails3.label
            }

            
            console.log('boxplotly js dataKey3', dataKey3, group_data_array)
            let trace1 = {
              y: groups_dataSample_array[dataKey3].map(s => group_data_array[dataKey3].data[s]),
              marker: {
                color: darkenHex(catDetails3.color),
                symbol: cohortMarker
              },
              type: 'box',
              boxpoints: 'all',
              jitter: 0.4,
              pointpos: 0,
              showlegend: false,
              opacity: cohortOpacity,
              offsetgroup: offsetgroups[offset_idx]
            }
            offset_idx += 1
            console.log('boxplotly js offsetgroup', dataKeys, offset_idx, offsetgroups[offset_idx], catDetails3.label)
            let pValue;
            // if (numCohortAvailable === 2) {
            //   // layout.xaxis.categoryarray = cohortSelected
              
            // }
            trace1.x = new Array(groups_dataSample_array[dataKey3].length).fill(xaxis_label_A);
            // trace2.x = new Array(groupBSamples.length).fill(xaxis_label_B);
            // xaxis_label_array.push(cohort)
            // trace1.x = [new Array(groupASamples.length).fill(cohort),
            //             new Array(groupASamples.length).fill(xaxis_label_A)]
            // trace2.x = [new Array(groupASamples.length).fill(cohort),
            //             new Array(groupASamples.length).fill(xaxis_label_B)]
            // trace2.x = [cohort, dataKeys[1]]
              // trace2.x = new Array(groupBCat.length).fill(cat_cohort_label);
            let groupACategorySamples = groups_dataSample_array[dataKey3].map(s => group_data_array[dataKey3].data[s])
            // let groupACategoryValues = groupACategorySamples.map(s => group_data_array[dataKey3].data[s]).filter(el => el)
            group_cat_data_arrays_ptest.push(groupACategorySamples)
            let groupAValues = trace1.y.filter(el => el)
            // let groupBValues =  trace2.y.filter(el => el)
            
            var new_data = [trace1, 
                            // trace2
                          ]
            data.push(...new_data)
            plotted += 1
          })
          var pValue = 'NaN'
          if (group_cat_data_arrays_ptest.length === 2) {
            console.log('boxplotly js ptest', group_cat_data_arrays_ptest)
            pValue = ttest(group_cat_data_arrays_ptest[0], 
              group_cat_data_arrays_ptest[1]).pValue().toExponential(2).toString()
          } else {
            pValue = 'NaN'
          }

          if (!isNaN(pValue)){
            annotations.push({
              x: pVal_loc,
              y: 1.1,
              xref: 'x',
              yref: 'paper',
              text: pValue.includes('NaN') ? '' : `pValue:<br>${pValue}`,
              showarrow: false,
            })
          }

        }

      }) 
      console.log('boxplotly js plotted', plotted)
      let config = {
        responsive: true,
      }
      // console.log('boxplotly js pval', pValue)
      // layout.title = (pValue === 'NaN') ? track : `${track}<br>p-value = ${pValue}`,
      layout.annotations = annotations
      layout.title = track
      
      // 
      var trace_color_array = []
      Object.entries(trackDetails[stratifyByPrimary_]).forEach(([catName, catDetails4]) => {
        if (checkInput(catDetails4.label)) { return }
          // dataKeys.forEach(dataKey => {
        var dataKey3 = `${track} (${catDetails4.label})`
        cat_color_array.push(catDetails4.color)
        var trace_label = `${catDetails4.label}`
        if ('labelShown' in catDetails4) {
          trace_label = catDetails4.labelShown
        }
        var trace_response_color =   {
          x: [null],
          y: [null],
          type: 'box',
          name: trace_label,
          legendgroup: 'group1',
          showlegend: true,
          marker: {
            color: darkenHex(catDetails4.color)
          },
        }
        trace_color_array.push(trace_response_color)
      })
      // var trace_response_color =   {
      //   x: [null],
      //   y: [null],
      //   type: 'box',
      //   name: stratifyVar[studySelected]['class1_boxplotName'],
      //   legendgroup: 'group1',
      //   showlegend: true,
      //   marker: {
      //     color: colors[0]
      //   },
      // }
      // var trace_nonresponse_color =   {
      //   x: [null],
      //   y: [null],
      //   type: 'box',
      //   name: stratifyVar[studySelected]['class2_boxplotName'],
      //   legendgroup: 'group1',
      //   showlegend: true,
      //   marker: {
      //     color: colors[1]
      //   },
      // }
      var discovery_marker =   {
        y: [null],
        x: [null],
        mode: 'markers',
        type: 'scatter',
        name: 'Discovery cohort',
        legendgroup: 'group1',
        showlegend: true,
        marker: {
          symbol: 'triangle-up',
          color: '#111111'
        },
      }
      var validation_marker =   {
        y: [null],
        x: [null],
        mode: 'markers',
        type: 'scatter',
        name: 'Validation cohort',
        legendgroup: 'group1',
        showlegend: true,
        marker: {
          symbol: 'circle',
          color: '#111111'
        },
      }

      // data.push(trace_response_color)
      // data.push(trace_nonresponse_color)
      data.push(...trace_color_array)
      if (!singleCohortToShow){
        data.push(discovery_marker)
        data.push(validation_marker)
      }
      
      // layout.xaxis.categoryarray = xaxis_label_array
      console.log('boxplotly final data and layout', data, layout)
      Plotly.newPlot(divId, data, layout, config);
    // }
}

function checkInput(variable) {
  if (
    variable === null ||         // Checks for null
    Number.isNaN(variable) ||    // Checks for NaN
    variable === "" ||
    variable === "NaN"              // Checks for empty string
    // Optional additional checks:
    // variable === undefined || // Checks for undefined
    // (typeof variable === 'string' && variable.trim() === '') // Checks for whitespace only
  ) {
    console.log(`The value '${variable}' is empty or invalid.`);
    return true;
  }
  console.log(`The value '${variable}' is valid.`);
  return false;
}

function darkenHex(hex, percent =  20) {
    // 1. Clean the hex string and handle 3-digit shorthand
    let color 
    = hex.startsWith('#') ? hex.slice(1) : hex;

    if (color.length === 3) {
        // Expand shorthand form (e.g., "03F" to "0033FF")
        color = color.split('').map(char => char + char).join('');
    }

    if (color.length !== 6) {
        console.error("Invalid hex color code provided.");
        return hex;
    }

    // Convert percentage to a decimal ratio
    // Clamping the ratio between 0 and 1 (0% to 100%)
    const ratio = Math.max(0, Math.min(1, percent / 100));
    
    // 2. Process each RGB component
    const hexToRgbComponent = (start) => {
        // Parse the two-character hex component to an integer (0-255)
        const val = parseInt(color.substring(start, start + 2), 16);
        
        // Darken the value: newVal = val * (1 - ratio)
        // Ensure the new value is at least 0 (fully dark)
        const darkerVal = Math.max(0, Math.floor(val * (1 - ratio)));
        
        // Convert the new integer back to a two-character hex string, padded with '0'
        return darkerVal.toString(16).padStart(2, '0');
    };

    const r = hexToRgbComponent(0); // Red component (index 0)
    const g = hexToRgbComponent(2); // Green component (index 2)
    const b = hexToRgbComponent(4); // Blue component (index 4)

    // 3. Combine the components back into a hex string
    console.log('darkenHex', hex, `#${r}${g}${b}`)
    return `#${r}${g}${b}`;
}
